import { ApplicationMuiTheme } from 'Lib/themes/muiTheme';

export const muiStyles = (theme: ApplicationMuiTheme) => ({
    root: {
        backgroundColor: theme?.app?.applicationColors.backgroundPrimary ||
            '#FFFFFF',
        flexGrow: 1
    },
    pageTitle: { flexBasis: 'auto' as const },
    filterBar: { flexBasis: 'auto' as const },
    searchBar: { margin: 'auto 0' },
    filterSelection: { width: 'fit-content' as const },
    filterOption: {
        padding: '.3rem',
        marginLeft: '.75rem',
        fontSize: '.9rem',
        color: theme?.app?.clientTheme.colors.primaryColor ||
            '#375073',
        cursor: 'pointer' as const,
        '&:hover': {
            backgroundColor: theme?.app?.clientTheme.colors.buttons.primaryHoverLight ||
                '#bec6d470'
        }
    },
    selectedFilter: {
        backgroundColor: theme?.app?.clientTheme.colors.primaryColor ||
            '#375073',
        color: theme?.app?.applicationColors.enumColors.white ||
            '#FFF'
    },
    exportButtonContainer: {
        marginRight: '2rem',
        alignSelf: 'center' as const
    },
    exportIcon: {
        height: '16px',
        width: '24px'
    },
    gridContainer: { flexGrow: 1 },
    pageSelectorContainer: { padding: '0 0 1rem 1.5rem' }
});